import { IAppState } from '../../redux';

export function selectIsSubagentLimitExceed(state: IAppState): boolean {
  return !!state.publishTerms.message?.subAgentLimitExceed;
}
